import { render, staticRenderFns } from "./replyComment.vue?vue&type=template&id=a6d0a32c&scoped=true&"
import script from "./replyComment.vue?vue&type=script&lang=js&"
export * from "./replyComment.vue?vue&type=script&lang=js&"
import style0 from "./replyComment.vue?vue&type=style&index=0&id=a6d0a32c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6d0a32c",
  null
  
)

export default component.exports